import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { IoMdClose } from "react-icons/io";
import { MdArrowForwardIos } from "react-icons/md";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { IoColorPaletteOutline } from "react-icons/io5";
import { RiImageEditLine } from "react-icons/ri";
import { FaFileVideo, FaRegHeart } from "react-icons/fa";
import { BsPencil } from "react-icons/bs";
import { BsCheck2 } from "react-icons/bs";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { RxExit } from "react-icons/rx";
import { RiUserAddLine } from "react-icons/ri";
import { PiCaretDownLight } from "react-icons/pi";
import {
  deleteApiCaller,
  postApiCaller,
  putApiCaller,
} from "../../../../Libs/apiCaller";
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";
import Modal from "../../../../Components/Modals/Modall";
import { useNavigate } from "react-router-dom";
import { GoTrash } from "react-icons/go";
import profileImageGroup from "../../../../Assets/Images/multipleUsers.png";
import profileImageUser from "../../../../Assets/Images/user.png";
import { Menu } from "@headlessui/react";
import { BsTrash3 } from "react-icons/bs";

const isImageFile = (url) => {
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
  const videoExtensions = [".mp4", ".webm", ".mov", ".avi", ".mkv"];

  const lowerUrl = url.toLowerCase();

  // Check if URL contains image extension
  if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
    return true;
  }

  // Check if URL contains video extension
  if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
    return false;
  }
  // Default to image if no extension matches
  return true;
};

export default function ContactInfo({
  totalMedia,
  isMediaLoading,
  mediaList,
  setActiveSection,
  setShowProfileView,
  toggleAddGroupMember, // Receive the function to toggle AddGroupMember visibility
  isAdmin,
  groupActiveChat,
  setGroupActiveChat,
  updateGroupData,
  settings,
  setSettings,
  deleteGroup,
  removeAdminUser,
  handleMakeAdmin,
  chatConversationId,
  setAllMessages,
  setAllGroups,
  getMediaList,
  setSelectedUser,
  removeUserModal,
  setRemoveUserModal,
}) {
  const navigate = useNavigate();
  const [isMuted, setIsMuted] = useState(false);
  const [chatColor, setChatColor] = useState("#7104F8"); // default blue
  const [bgColor, setBgColor] = useState("#f3f4f6"); // default gray
  const [image, setImage] = useState(
    groupActiveChat?.mediaId?.imageUrl || profileImageGroup
  ); // Default image
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingError, setIsEditingError] = useState("");
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [groupName, setGroupName] = useState(
    groupActiveChat?.groupName || "Not Found"
  );
  const [description, setDescription] = useState(
    groupActiveChat?.description || ""
  );
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Create a reference for the dropdown
  const caretRef = useRef(null); // Create a reference for the caret icon
  const [timeoutId, setTImeoutId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteGroupModal, setDeleteGroupModal] = useState(false);
  const [deleteChatModal, setDeleteChatModal] = useState(false);
  let uid = localStorage.getItem("userId");

  // Toggle menu on caret click
  const toggleMenu = (userId) => {
    setIsOpen((prev) => ({
      ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
      [userId]: !prev[userId],
    }));
  };

  const [showNotif, setShowNotif] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowNotif(true);
    }, 50);
  }, []);

  useEffect(() => {
    if (settings) {
      setChatColor(settings.chatColor);
      setBgColor(settings.background);
      setIsMuted(settings.muteNotification);
    }
  }, [settings]);

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        caretRef.current &&
        !caretRef.current.contains(event.target)
      ) {
        setIsOpen({});
      }
    };

    // Add event listener for clicks outside
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Function to check if current user is admin
  const isUserAdmin = () => {
    if (!groupActiveChat?.adminId) return false;
    return (
      groupActiveChat.adminId.some((admin) => admin?._id === uid) ||
      groupActiveChat?.groupCreatedBy?._id === uid
    );
  };

  const handleNameChange = (e) => {
    setGroupName(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const saveGroupName = () => {
    if (groupName.trim() === "") {
      setIsEditingError("Group Name cannot be empty");
      return;
    }
    if (groupName !== groupActiveChat?.groupName) {
      updateGroupData("groupName", groupName);
    }
    setIsEditingError("");
    setIsEditingName(false);
  };

  const saveDescription = () => {
    // if (description.trim() === "") {
    //   setIsEditingError("Description cannot be empty");
    //   return;
    // }
    if (description !== groupActiveChat?.description) {
      updateGroupData("description", description);
    }
    setIsEditingError("");
    setIsEditingDescription(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size > 10 * 1024 * 1024) {
      toast.error("Image size should be less than 10MB");
      return;
    }

    if (file) {
      setImage(URL.createObjectURL(file));
      updateGroupData("messageMedia", file);
    }
  };

  const handleSettingsChange = async (
    chtColor = chatColor,
    bgClr = bgColor,
    isMtd = isMuted
  ) => {
    const endpoint = `setting/add`;
    const response = await postApiCaller(endpoint, {
      chatColor: chtColor,
      background: bgClr,
      muteNotification: isMtd,
      groupId: groupActiveChat._id,
    });

    setSettings({
      chatColor: chtColor,
      background: bgClr,
      muteNotification: isMtd,
    });
  };

  const createChat = async (createChatId) => {
    const endPoint = "chat/create";
    const response = await postApiCaller(endPoint, { user: createChatId });
    if (response?.status === 200) {
      navigate("/home", {
        state: { chat: response.data.data },
      });
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const deleteChat = async () => {
    const endPoint = `messages/allChat/${chatConversationId._id}`;
    const response = await deleteApiCaller(endPoint);
    if (response?.status === 200) {
      setAllGroups((prev) =>
        prev.map((group) =>
          group._id === groupActiveChat._id
            ? { ...group, latestMessage: {} }
            : group
        )
      );
      setAllMessages([]);
      getMediaList();
      toast.success("Chat deleted successfully");
      setDeleteChatModal(false);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const downloadFile = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = url;
    a.click();
  };

  const handleRemoveAsAmdin = async (user) => {
    const endPoint = `group/remove-admin/${groupActiveChat._id}`;
    const payload = {
      adminIdToRemove: user._id,
    };
    const response = await putApiCaller(endPoint, payload);
    if (response?.status === 200) {
      setGroupActiveChat({
        ...groupActiveChat,
        adminId: groupActiveChat.adminId.filter(
          (admin) => admin._id !== user._id
        ),
      });
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const sortUsers = useMemo(() => {
    if (
      !groupActiveChat?.users ||
      !groupActiveChat?.adminId ||
      !groupActiveChat?.groupCreatedBy
    )
      return [];

    // Get group creator user
    const creatorUser = groupActiveChat.users.find(
      (user) => user._id === groupActiveChat.groupCreatedBy._id
    );

    // Get admin users except group creator
    const adminUsers = groupActiveChat.users.filter(
      (user) =>
        groupActiveChat.adminId.some((admin) => admin._id === user._id) &&
        user._id !== groupActiveChat.groupCreatedBy._id
    );

    // Get non-admin users
    const nonAdminUsers = groupActiveChat.users
      .filter(
        (user) =>
          !groupActiveChat.adminId.some((admin) => admin._id === user._id) &&
          user._id !== groupActiveChat.groupCreatedBy._id
      )
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    return [
      ...(creatorUser ? [creatorUser] : []),
      ...adminUsers,
      ...nonAdminUsers,
    ];
  }, [groupActiveChat]);

  return (
    <>
      <section>
        <div className="sticky  w-full min-h-[67px] py-2.5 bg-white flex items-center justify-between border-b  text-black p-4 text-center">
          <div className="">
            <div className="w-full items-center bg-white text-black flex gap-4 ">
              <IoMdClose
                onClick={() => setShowProfileView(false)}
                className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
              />
              <h1 className="text-lg font-semibold text-center ">Group Info</h1>
            </div>
          </div>
        </div>
        <div className="bg-[#f9f6fe] justify-center h-[calc(100vh-80px)] min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] gap-2 overflow-y-auto overflow-x-hidden">
          <div className="bg-white pb-4 rounded-b-lg">
            <div className="profile-section p-4 pt-6 rounded-xl max-w-md flex flex-col justify-center items-center gap-4 text-center">
              <div className="avatar">
                <div className="relative">
                  <div className="w-[160px] h-[160px] rounded-full overflow-hidden">
                    <img
                      src={image ? image : groupActiveChat?.mediaId?.imageUrl}
                      alt="Group"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  {isUserAdmin() && (
                    <label
                      htmlFor="group-file-upload"
                      className="bg-[var(--primary-color)] absolute top-0 right-4 w-fit rounded-full p-2 cursor-pointer hover:opacity-50 z-30"
                    >
                      <BsPencil className="text-white text-xl" />
                    </label>
                  )}
                  <input
                    type="file"
                    id="group-file-upload"
                    name="group-file-upload"
                    accept=".jpg,.png"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                </div>
              </div>

              <div>
                <div className="flex items-center z-10 gap-2">
                  {isEditingName ? (
                    <div className="relative flex flex-col items-center gap-2">
                      <input
                        type="text"
                        maxLength={30}
                        value={groupName}
                        onChange={handleNameChange}
                        className="relative text-md font-semibold text-black p-2 pr-10 px-4 border w-80 rounded-lg border-gray-300 focus:outline-none"
                      />
                      {isEditingError && (
                        <p className="text-red-500 text-sm">{isEditingError}</p>
                      )}
                      <BsCheck2
                        className="absolute right-3 top-3 text-black text-xl cursor-pointer"
                        onClick={saveGroupName}
                      />
                    </div>
                  ) : (
                    <h2 className="text-lg font-semibold text-black pt-1 truncate max-w-xs">
                      {groupName}
                    </h2>
                  )}
                  {isUserAdmin() && !isEditingName && (
                    <BsPencil
                      className="cursor-pointer transform text-[var(--primary-color)]"
                      onClick={() => setIsEditingName(!isEditingName)}
                    />
                  )}
                </div>
                <div className="flex pt-2 items-center gap-2 text-sm text-base-content opacity-70">
                  <span className="text-black text-center flex justify-center mx-auto font-normal">
                    {groupActiveChat?.users?.length || 0} Member
                    {(groupActiveChat?.users?.length || 0) > 1 && "s"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-1 bg-white pb-4 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
                Group Description
              </h3>
              {isUserAdmin() && !isEditingDescription && (
                <BsPencil
                  className="cursor-pointer transform text-[var(--primary-color)]"
                  onClick={() => setIsEditingDescription(!isEditingDescription)}
                />
              )}
            </div>
            {isEditingDescription ? (
              <div className="relative flex flex-col items-center gap-2">
                <textarea
                  value={description}
                  onChange={handleDescriptionChange}
                  rows={3}
                  maxLength={100}
                  className="text-[15px] font-semibold pr-8 text-black p-2 px-4 border w-96 mt-3 rounded-lg border-gray-300 focus:outline-none resize-none"
                />
                {isEditingError && (
                  <p className="text-red-500 text-sm">{isEditingError}</p>
                )}
                <BsCheck2
                  className="absolute top-[23px] right-3 text-black text-xl cursor-pointer"
                  onClick={saveDescription}
                />
              </div>
            ) : (
              <p className="text-[15px] text-black font-semibold break-words whitespace-pre-wrap">
                {description}
              </p>
            )}
          </div>

          <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
                Media, Links & Documents
              </h3>
              <div onClick={() => setActiveSection("media")}>
                <h3 className="hover:underline cursor-pointer hover:text-[var(--primary-color)] text-sm flex items-center gap-1 font-normal text-[#7C7C7C] mb-1">
                  {totalMedia}
                  <MdArrowForwardIos className="group-hover:text-[var(--primary-color)]" />
                </h3>
              </div>
            </div>

            <div className="flex gap-5 mt-2">
              {isMediaLoading ? (
                <div className="flex items-center justify-center w-full h-full">
                  <FadeLoader color="#7104F8" loading={true} size={12} />
                </div>
              ) : mediaList.length > 0 ? (
                mediaList.slice(0, 4).map((msg, index) => (
                  <div
                    key={index}
                    className="min-w-[80px] min-h-[80px] rounded-xl overflow-hidden cursor-pointer"
                    onClick={() =>
                      isImageFile(msg.mediaUrl) && downloadFile(msg.mediaUrl)
                    }
                  >
                    {msg.mediaId.fileType === "video" ? (
                      <video
                        controls
                        src={msg.mediaUrl}
                        className="h-[80px] object-contain"
                      />
                    ) : (
                      <img
                        src={msg.mediaUrl}
                        alt={`media-${index}`}
                        className="h-[80px] w-full object-cover"
                      />
                    )}
                  </div>
                ))
              ) : (
                <div className="flex items-center justify-center h-full">
                  <p className="text-gray-500">No media found</p>
                </div>
              )}
            </div>
          </div>

          <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4">
            {/* Mute Notification */}
            <div className="flex justify-between items-center">
              <div>
                <p className="flex items-center gap-2 text-black font-semibold">
                  <HiOutlineSpeakerWave className="text-xl" /> Mute
                  Notifications
                </p>
              </div>
              <div>
                <label for="toggle" class="flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isMuted}
                    onChange={(ev) => {
                      setIsMuted(ev.target.checked);
                      if (timeoutId) {
                        clearTimeout(timeoutId);
                      }
                      setTImeoutId(
                        setTimeout(() => {
                          handleSettingsChange(
                            chatColor,
                            bgColor,
                            ev.target.checked
                          );
                        }, 500)
                      );
                    }}
                    id="toggle"
                    class="sr-only peer"
                  />
                  <div
                    className={`${
                      showNotif ? "block" : "hidden"
                    } relative w-14 h-7 p-1 rounded-full before:absolute before:bg-white before:w-5 before:h-5 before:p-1 before:rounded-full before:transition-all before:duration-500 before:left-1 peer-checked:before:left-8 peer-checked:before:bg-white ${
                      isMuted
                        ? "bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)]"
                        : "bg-[#E5E7EB]"
                    }`}
                  ></div>
                </label>
              </div>
            </div>

            {/* Custom Chat Color Picker */}
            {/* <div className="flex justify-between items-center pt-3">
              <p className="flex items-center gap-2 text-black font-semibold">
                <IoColorPaletteOutline className="text-xl" />
                Custom Chat Color
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={chatColor}
                  onChange={(e) => {
                    setChatColor(e.target.value);
                    if (timeoutId) {
                      clearTimeout(timeoutId);
                    }
                    setTImeoutId(
                      setTimeout(() => {
                        handleSettingsChange(e.target.value, bgColor, isMuted);
                      }, 500)
                    );
                  }}
                  className="w-7 cursor-pointer rounded-xl h-8 border-0 bg-transparent"
                />
              </div>
            </div> */}

            {/* Custom Background Color Picker */}
            <div className="flex justify-between items-center pt-2">
              <p className="flex items-center gap-2 text-black font-semibold">
                <RiImageEditLine className="text-xl" />
                Custom Background Color
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={bgColor}
                  onChange={(e) => {
                    setBgColor(e.target.value);

                    if (timeoutId) {
                      clearTimeout(timeoutId);
                    }
                    setTImeoutId(
                      setTimeout(() => {
                        handleSettingsChange(
                          chatColor,
                          e.target.value,
                          isMuted
                        );
                      }, 500)
                    );
                  }}
                  className="w-7 cursor-pointer rounded-xl h-8 border-none bg-transparent"
                />
              </div>
            </div>
          </div>

          <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4 space-y-5">
            <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
              {groupActiveChat?.users?.length || 0} Member
              {(groupActiveChat?.users?.length || 0) > 1 && "s"}
            </h3>

            {/* Circle Image Placeholder */}
            {isUserAdmin() && (
              <div className="flex items-center gap-2">
                <button
                  className=" flex gap-2 items-center justify-center rounded-full"
                  onClick={() => toggleAddGroupMember(true)}
                >
                  <div className="bg-[#F9F7FF] rounded-full w-12 h-12 flex items-center justify-center">
                    <RiUserAddLine className="text-xl text-[var(--primary-color)]" />
                  </div>
                  <span className="font-semibold text-black">Add Members</span>
                </button>
              </div>
            )}
            {/* The Group Members */}
            {sortUsers.map((user) => (
              <div className="flex items-start justify-between space-x-2 w-full">
                <div className="flex items-center gap-2 w-full">
                  <div className="min-w-12 min-h-12 max-w-12 max-h-12 rounded-full">
                    <img
                      src={
                        user?.userImage || user?.avtarImage || profileImageUser
                      }
                      alt=""
                      className={`${
                        user?.userImage || user?.avtarImage
                          ? "max-w-[46px] max-h-[46px] rounded-full min-w-[46px] min-h-[46px] object-cover object-center"
                          : "object-cover max-w-[46px] max-h-[46px] p-1 rounded-full"
                      }`}
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center w-full justify-between">
                      <p className="text-black font-semibold text-[15px]">
                        {user?.name}
                      </p>
                      <div className="flex items-center gap-2">
                        {groupActiveChat.groupCreatedBy?._id === user._id && (
                          <span className="bg-[#06B300] text-white text-xs px-2 py-1 rounded-full">
                            Group Owner
                          </span>
                        )}
                        {groupActiveChat.adminId.some(
                          (ele) =>
                            ele._id == user._id &&
                            ele._id !== groupActiveChat.groupCreatedBy._id
                        ) && (
                          <span className="bg-[#06B300] text-white text-xs px-2 py-1 rounded-full">
                            Group Admin
                          </span>
                        )}
                        {groupActiveChat.adminId.some(
                          (ele) => ele._id == user._id
                        ) ? (
                          <div className="flex items-center gap-2">
                            {user?._id == uid && (
                              <Menu
                                as="div"
                                className="invisible relative inline-block text-left"
                              >
                                <div>
                                  <Menu.Button className="text-black text-xl cursor-pointer focus:outline-none">
                                    <PiCaretDownLight />
                                  </Menu.Button>
                                </div>

                                <Menu.Items className="absolute right-0 w-max origin-top-right bg-white shadow-[0px_0px_100px_0px_#00000033] rounded-md z-10 focus:outline-none">
                                  <div className="py-1 text-sm">
                                    <Menu.Item>
                                      {({ active }) => (
                                        <div
                                          onClick={() => createChat(user._id)}
                                          className={`p-3 cursor-pointer ${
                                            active ? "bg-gray-100" : ""
                                          }`}
                                        >
                                          Message {user?.name}
                                        </div>
                                      )}
                                    </Menu.Item>

                                    {isUserAdmin() && (
                                      <Menu.Item>
                                        {({ active }) => (
                                          <div
                                            onClick={() =>
                                              handleRemoveAsAmdin(user)
                                            }
                                            className={`p-3 cursor-pointer text-red-500 ${
                                              active ? "bg-gray-100" : ""
                                            }`}
                                          >
                                            Remove As Admin
                                          </div>
                                        )}
                                      </Menu.Item>
                                    )}
                                  </div>
                                </Menu.Items>
                              </Menu>
                            )}
                            {user?._id !== uid && (
                              <Menu
                                as="div"
                                className="relative inline-block text-left"
                              >
                                <div>
                                  <Menu.Button className="text-black text-xl cursor-pointer focus:outline-none">
                                    <PiCaretDownLight />
                                  </Menu.Button>
                                </div>

                                <Menu.Items className="absolute right-0 w-max origin-top-right bg-white shadow-[0px_0px_100px_0px_#00000033] rounded-md z-10 focus:outline-none">
                                  <div className="py-1 text-sm">
                                    <Menu.Item>
                                      {({ active }) => (
                                        <div
                                          onClick={() => createChat(user._id)}
                                          className={`p-3 cursor-pointer ${
                                            active ? "bg-gray-100" : ""
                                          }`}
                                        >
                                          Message {user?.name}
                                        </div>
                                      )}
                                    </Menu.Item>

                                    {isUserAdmin() &&
                                      user?._id !==
                                        groupActiveChat?.groupCreatedBy
                                          ?._id && (
                                        <Menu.Item>
                                          {({ active }) => (
                                            <div
                                              onClick={() =>
                                                handleRemoveAsAmdin(user)
                                              }
                                              className={`p-3 cursor-pointer text-red-500 ${
                                                active ? "bg-gray-100" : ""
                                              }`}
                                            >
                                              Remove As Admin
                                            </div>
                                          )}
                                        </Menu.Item>
                                      )}
                                  </div>
                                </Menu.Items>
                              </Menu>
                            )}
                          </div>
                        ) : (
                          <Menu
                            as="div"
                            className="relative inline-block text-left"
                          >
                            {user?._id !== uid && (
                              <div>
                                <Menu.Button className="text-black text-xl cursor-pointer focus:outline-none">
                                  <PiCaretDownLight />
                                </Menu.Button>
                              </div>
                            )}

                            <Menu.Items className="absolute right-0 w-max origin-top-right bg-white shadow-[0px_0px_100px_0px_#00000033] rounded-md z-10 focus:outline-none">
                              <div className="py-1 text-sm">
                                {user?._id !== uid && (
                                  <Menu.Item>
                                    {({ active }) => (
                                      <div
                                        onClick={() => createChat(user._id)}
                                        className={`p-3 cursor-pointer ${
                                          active ? "bg-gray-100" : ""
                                        }`}
                                      >
                                        Message {user?.name}
                                      </div>
                                    )}
                                  </Menu.Item>
                                )}

                                {isUserAdmin() &&
                                  user._id !==
                                    groupActiveChat.groupCreatedBy._id && (
                                    <Menu.Item>
                                      {({ active }) => (
                                        <div
                                          onClick={() => handleMakeAdmin(user)}
                                          className={`p-3 cursor-pointer ${
                                            active ? "bg-gray-100" : ""
                                          }`}
                                        >
                                          Make Group Admin
                                        </div>
                                      )}
                                    </Menu.Item>
                                  )}

                                {isUserAdmin() &&
                                  user._id !==
                                    groupActiveChat.groupCreatedBy._id && (
                                    <Menu.Item>
                                      {({ active }) => (
                                        <div
                                          onClick={() => {
                                            if (
                                              groupActiveChat?.adminId.find(
                                                (ele) => ele._id === uid
                                              )
                                            ) {
                                              setSelectedUser(user);
                                              setRemoveUserModal(true);
                                            }
                                          }}
                                          className={`p-3 cursor-pointer text-red-500 ${
                                            active ? "bg-gray-100" : ""
                                          }`}
                                        >
                                          Remove {user?.name}
                                        </div>
                                      )}
                                    </Menu.Item>
                                  )}
                              </div>
                            </Menu.Items>
                          </Menu>
                        )}
                      </div>
                    </div>
                    <p className="text-xs text-gray-500 pt-1 w-80 overflow-hidden text-ellipsis whitespace-nowrap">
                      {user?.about}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4 space-y-5">
            <div className="flex justify-between items-center">
              <div className="cursor-pointer">
                <p
                  className="text-[15px] flex items-center gap-2 text-[#F44336] font-semibold hover:opacity-55"
                  onClick={() => {
                    setDeleteChatModal(true);
                  }}
                >
                  <GoTrash className="text-xl text-[#F44336]" />
                  Delete Group Chat
                </p>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="cursor-pointer">
                <p
                  className="text-[15px] flex items-center gap-2 text-[#F44336] font-semibold hover:opacity-55"
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                >
                  <RxExit className="text-xl text-[#F44336]" />
                  Exit Group
                </p>
              </div>
            </div>
            {groupActiveChat?.groupCreatedBy?._id === uid && (
              <div className="flex justify-between items-center">
                <div className="cursor-pointer">
                  <p
                    className="text-[15px] flex items-center gap-2 text-[#f05348] font-semibold hover:opacity-55"
                    onClick={() => {
                      setDeleteGroupModal(true);
                    }}
                  >
                    <BsTrash3 className="text-xl text-[#f05348]" />
                    Delete Group
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <Modal
        isOpen={removeUserModal}
        onClose={() => setRemoveUserModal(false)}
        onConfirm={removeAdminUser}
        description="Are you sure you want to remove this user?"
        title="Remove user"
      />
      <Modal
        isOpen={deleteChatModal}
        onClose={() => setDeleteChatModal(false)}
        onConfirm={deleteChat}
        description="Are you sure you want to delete this group chat?"
        title="Delete Chat"
      />
      <Modal
        isOpen={deleteModal}
        onClose={() => setDeleteModal(false)}
        onConfirm={() => deleteGroup("Exit group")}
        description="Are you sure you want to exit this group?"
        title="Exit group"
      />
      <Modal
        isOpen={deleteGroupModal}
        onClose={() => setDeleteGroupModal(false)}
        onConfirm={() => deleteGroup("Delete Group")}
        description="Are you sure you want to delete this group?"
        title="Delete Group"
      />
    </>
  );
}
